// extracted by mini-css-extract-plugin
export default {"boxSmall":"style_boxSmall__uJfTi","card":"style_card__4Ds5r"};